import ApiService from "@/common/api.service";
import {
  FETCH_USERS,
  FETCH_USER,
  UPDATE_USER,
  CREATE_USER,
  RESET_USER,
  DELETE_USER
} from "./actions.type";
import { FETCH_USER_START, SET_USERS, SET_USER } from "./mutations.type";

const state = {
  users: [],
  usersCount: 1,
  user: {},
  isLoading: false
};

const getters = {
  usersCount: state => state.usersCount,
  users: state => state.users,
  user: state => state.user,
  isLoading: state => state.isLoading
};

const actions = {
  [FETCH_USERS](context, [filteringCriteria, search]) {
    context.commit(FETCH_USER_START);
    return ApiService.filteredCollection(
      "users",
      filteringCriteria,
      search
    ).then(({ data }) => {
      context.commit(SET_USERS, data);
    });
  },
  [FETCH_USER](context, id) {
    return ApiService.get("users", id).then(({ data }) => {
      context.commit(SET_USER, data);
    });
  },
  [UPDATE_USER](context, payload) {
    return ApiService.put(`users/${payload.id}`, payload);
  },
  [CREATE_USER](context, payload) {
    return ApiService.post("users", payload);
  },
  [RESET_USER](context) {
    context.commit(SET_USER, {});
  },
  [DELETE_USER](context, id) {
    return ApiService.delete("users", id);
  }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
  [FETCH_USER_START](state) {
    state.isLoading = true;
  },
  [SET_USERS](state, data) {
    state.users = data.items || [];
    state.usersCount = data.total || 1;
    state.isLoading = false;
  },
  [SET_USER](state, data) {
    state.user = data;
    state.isLoading = false;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
